import * as Sentry from "@sentry/react";

const SENTRY_PROJECT = "vogue-frontend";

function getTracePropagationTargets(): Sentry.BrowserOptions["tracePropagationTargets"] {
  const apiUrl = import.meta.env.VITE_API_URL;

  if (!apiUrl) {
    return ["localhost", /^\//];
  }

  try {
    return [new URL(apiUrl).origin];
  } catch {
    return [apiUrl];
  }
}

export function initializeSentry() {
  const environment = import.meta.env.VITE_ENVIRONMENT;
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.log("No SENTRY_DSN found");

    return;
  }

  Sentry.init({
    dsn,
    environment,
    release: import.meta.env.VITE_SENTRY_RELEASE_NAME,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: getTracePropagationTargets(),
    sendDefaultPii: false,
  });

  Sentry.setTag("project", SENTRY_PROJECT);
}
